/**
 * Permission codes the cost-accounting screens declare an interest in
 * (`internal/cost/permissions.go`, design C3 §6.1).
 *
 * `cost.cycle.manage` and `cost.run.post` are a declared segregation-of-duties
 * pair (§6.1): whoever writes the allocation rules that decide which cost object
 * bears a cost must not be the one who puts them into the ledger. The role
 * editor refuses to combine them, and the screens here reflect that by never
 * offering Post on a screen that also offers step editing — the run detail is
 * where posting lives, the cycle editor is where the rules live.
 */

export const COST_PERMISSIONS = {
  poolRead: 'cost.pool.read',
  poolManage: 'cost.pool.manage',

  driverRead: 'cost.driver.read',
  driverManage: 'cost.driver.manage',

  cycleRead: 'cost.cycle.read',
  cycleManage: 'cost.cycle.manage',

  runCalculate: 'cost.run.calculate',
  /** Step-up MFA server-side: posting an allocation moves the ledger. */
  runPost: 'cost.run.post',

  rateManage: 'cost.rate.manage',
  reportRead: 'cost.report.read',

  /** Read the chart of accounts to fill the pool's clearing/absorbed pickers. */
  accountRead: 'gl.account.read',
  /** Read companies for the company picker every screen starts from. */
  companyRead: 'org.company.read',
  /** Read fiscal periods: a driver quantity and a run are both per period. */
  periodRead: 'org.period.read',
} as const

export type CostPermission = (typeof COST_PERMISSIONS)[keyof typeof COST_PERMISSIONS]
